var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4257_47145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5391 24.4803C13.3347 24.4803 14.0978 24.1642 14.6604 23.6016C15.223 23.039 15.5391 22.276 15.5391 21.4803H9.53906C9.53906 22.276 9.85513 23.039 10.4177 23.6016C10.9804 24.1642 11.7434 24.4803 12.5391 24.4803ZM12.5391 3.35732L11.3436 3.59882C9.9875 3.87512 8.76856 4.61147 7.89304 5.68325C7.01752 6.75503 6.53921 8.09639 6.53906 9.48032C6.53906 10.4223 6.33806 12.7758 5.85056 15.0933C5.61056 16.2438 5.28656 17.4423 4.85606 18.4803H20.2221C19.7916 17.4423 19.4691 16.2453 19.2276 15.0933C18.7401 12.7758 18.5391 10.4223 18.5391 9.48032C18.5386 8.09665 18.0601 6.75564 17.1846 5.68417C16.3091 4.6127 15.0904 3.87656 13.7346 3.60032L12.5391 3.35582V3.35732ZM21.8691 18.4803C22.2036 19.1508 22.5906 19.6818 23.0391 19.9803H2.03906C2.48756 19.6818 2.87456 19.1508 3.20906 18.4803C4.55906 15.7803 5.03906 10.8003 5.03906 9.48032C5.03906 5.85032 7.61906 2.82032 11.0466 2.12882C11.0256 1.92025 11.0486 1.70961 11.1141 1.51048C11.1796 1.31135 11.2861 1.12815 11.4267 0.972703C11.5673 0.817256 11.739 0.693008 11.9306 0.607973C12.1222 0.522938 12.3294 0.479004 12.5391 0.479004C12.7487 0.479004 12.956 0.522938 13.1476 0.607973C13.3392 0.693008 13.5108 0.817256 13.6514 0.972703C13.7921 1.12815 13.8985 1.31135 13.964 1.51048C14.0295 1.70961 14.0525 1.92025 14.0316 2.12882C15.727 2.47367 17.2511 3.39386 18.3459 4.73357C19.4407 6.07328 20.0388 7.75018 20.0391 9.48032C20.0391 10.8003 20.5191 15.7803 21.8691 18.4803Z",
    fill: "#212529"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4257_47145"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.539062 0.480347)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.474f8a37195b9ff48e2391ae939563d1.svg";
export { ForwardRef as ReactComponent };